import React from "react";
import "./styled.css";
import { FaWhatsapp } from "react-icons/fa";
import ReactGa from "react-ga";

const WHATSAPP_URL =
  "https://api.whatsapp.com/send?phone=5491162255399&text=%C2%A1Hola!%20Ingres%C3%A9%20desde%20la%20web.%20Quiero%20cotizar%20un%20seguro%20de%20Bici.";

const BotonFlotante = () => {
  const medicionClick = () => {
    ReactGa.event({
      category: "WhatsApp",
      action: "Click",
    });
  };

  const handleClick = () => {
    medicionClick();
    window.open(WHATSAPP_URL, "_blank");
  };

  return (
    <div className="boton-flotante" onClick={handleClick}>
      <div className="icono-messenger">
        <FaWhatsapp size={24} />
      </div>
    </div>
  );
};

export default BotonFlotante;
